import { createSelector } from "reselect";

export const configCiTestCasesSelector = createSelector(
    state => state.services.configCiTestCases,
    state => state
);
